/*export * from './SystemInfo';
export * from './IpAddressTable';
export * from './IpRouteTable';
export * from './BridgePortTable';
export * from './BridgePortFdbTable';
export * from './AssetTable';
export * from './Win32_NetworkAdapterConfigTable';
export * from './IfTable';
export * from './ProductInfo';
export * from './IfCdpTable'
export * from './InstalledSoftwareTable';
export * from './VlanTable';
export * from './Win32_ComputerSystemInfo';
export * from './Win32_DiskDriveTable';
export * from './Win32_InstalledSoftwareTable';
export * from './Win32_LogicalDiskTable';
export * from './Win32_NetworkAdapterConfigTable';
export * from './Win32_NetworkAdapterTable';
export * from './Win32_OperatingSystemInfo';
export * from './Win32_ProcessorTable';
export * from './ApClientTable';
export * from './InfoSetNames';
export * from './MonitorTable';*/

export * from './IfTable';
export * from './InfoSetNames';
